import { Link } from "react-router-dom";
import { Clock, Mail, Phone } from "lucide-react";
import { PortalShell } from "@/components/PortalShell";
import { useAuth } from "@/lib/auth";

export default function PendingApproval() {
  const { user } = useAuth();
  if (!user) {
    return (
      <PortalShell showNav={false}>
        <p className="text-slate-600">Please <Link to="/trade/login" className="text-cyan-600 font-semibold">sign in</Link>.</p>
      </PortalShell>
    );
  }
  if (user.status === "approved" || user.role === "admin") {
    return (
      <PortalShell>
        <p>You're approved. <Link className="text-cyan-600" to="/trade">Go to dashboard →</Link></p>
      </PortalShell>
    );
  }
  return (
    <PortalShell showNav={false}>
      <div className="max-w-2xl mx-auto text-center py-12">
        <div className="mx-auto w-16 h-16 rounded-2xl bg-amber-100 flex items-center justify-center mb-6">
          <Clock className="w-8 h-8 text-amber-600" />
        </div>
        <h1 className="font-display text-3xl lg:text-4xl font-bold text-slate-900">Application under review</h1>
        <p className="mt-4 text-slate-600 max-w-md mx-auto">
          Thanks {user.full_name.split(" ")[0]} — we've received your application for <strong>{user.company_name}</strong>. Our trade team typically responds within 1 business day.
        </p>
        <div className="mt-8 inline-flex flex-col sm:flex-row gap-3 items-center text-sm">
          <a href="mailto:lab@awarewatertesting.com.au" className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-slate-900 text-white hover:bg-slate-800 transition-colors">
            <Mail className="w-4 h-4" /> Email the team
          </a>
          <a href="tel:+61753273473" className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white border border-slate-200 text-slate-900 hover:border-slate-300 transition-colors">
            <Phone className="w-4 h-4" /> (07) 5327 3473
          </a>
        </div>
      </div>
    </PortalShell>
  );
}
